// extracted by mini-css-extract-plugin
export var cardSelected = "_ic-2";
export var image = "_ic-1";
export var table = "_ic-0";